import { FaFileSignature, FaInfoCircle, FaSpinner } from "react-icons/fa"
import { toast } from "react-toastify"
import { BACKEND } from "../config/configEnvs"
import { useEffect, useState } from "react"
import axios from "axios"
import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Modal from "../components/ui/Modal"
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { FormatMinutesToHours } from "../utils/FormatDate"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"

const ReporteDiario = () => {

  const [page, setPage] = useState(1) // Paginador
  const [limit, setLimit] = useState(25) // Límite

  const [activeModal, setActiveModal] = useState(false) // Estado del modal

  const [totalPages, setTotalPages] = useState(0) // Paginas totales
  const [totalDocs, setTotalDocs] = useState(0) // Documentos totales

  const [reportsLoading, setReportsLoading] = useState(false) // Estado de carga de los reportes

  const [workers, setWorkers] = useState([]) // Lista de trabajadores
  const [selectedWorker, setSelectedWorker] = useState("Todos") // Trabajador seleccionado

  const [reportDate, setReportDate] = useState("") // Fecha del reporte

  const [reports, setReports] = useState([]) // Reportes en total
  const [reportSelected, setReportSelected] = useState({}) // Reporte seleccioando, se muestra en el modal

  const totalMinutesByReport = reportSelected ? reportSelected.tasksWorked?.reduce((acc, item) => acc + item.time, 0) : 0

  const getReports = async () => { // Obtener los reportes del backend
    try {
      setReportsLoading(true)
      let url = `${BACKEND}/api/reporteDiario?page=${page}&limit=${limit}`

      if (selectedWorker !== "Todos") {
        url += `&where[user][equals]=${selectedWorker}` // Si hay un trabajador seleccionado se añade a la query
      }

      if (reportDate !== "") {
        const date = new Date(reportDate);
        const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
        url += `&where[date][greater_than_equal]=${formattedDate}`;
      }

      const response = await axios.get(url)
      setReports(response.data.docs)
      setTotalPages(response.data.totalPages)
      setTotalDocs(response.data.totalDocs)
      setReportsLoading(false)
    } catch (error) {
      console.log(error)
      toast.error("Error")
    }
  }

  const getWorkers = async () => { // Obtener la lista de trabajadores
    try {
      const workers = await axios.get(`${BACKEND}/api/trabajadores?where[activo][equals]=true&limit=0`)
      setWorkers(workers.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error obteniendo los trabajdores: " + error)
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const formatDate = (date) => { // Formatear la fecha actual
    const d = new Date(date);
  
    const daysOfWeek = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    const monthsOfYear = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio", 
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];
  
    const dayOfWeek = daysOfWeek[d.getDay()];  // Día de la semana
    const day = String(d.getDate()).padStart(2, '0');  // Día con 2 dígitos
    const month = monthsOfYear[d.getMonth()];  // Nombre del mes
    const year = d.getFullYear();  // Año completo
    const hours = String(d.getHours()).padStart(2, '0');  // Hora con 2 dígitos
    const minutes = String(d.getMinutes()).padStart(2, '0');  // Minutos con 2 dígitos
  
    return `${dayOfWeek}, ${day} de ${month}, ${year} - ${hours}:${minutes}`;
  };
  
  // Funciones de arranque de componente
  useEffect(() => {
    getReports()
    getWorkers()
  }, [])

  useEffect(() => { // Cada que se cambia la pagina o el límite se traen los reportes
    getReports()
  }, [page, limit, selectedWorker, reportDate])

  return (
      <div className="w-full flex flex-col h-screen">

        <Modal // Modal para ver el reporte
          activeModal={activeModal}
          title={`Reporte del día`}
          onClose={() => {
            setActiveModal(false)
            setReportSelected({})
          }}
          centered={true}
        >
          <div className="flex flex-col gap-4">

            <div className="flex flex-row gap-4 text-xs">
              <span className="font-bold">Trabajador</span>
              <span>{reportSelected?.user?.name}</span>
            </div>

            <div className="flex flex-row gap-4 text-xs justify-between">
              <span className="flex flex-row gap-4">
                <span className="font-bold">Fecha</span>
                <span>{formatDate(reportSelected?.date)}</span>
              </span>
              <span className="flex flex-row gap-4">
                <span className="font-bold">Horas trabajadas</span>
                {FormatMinutesToHours(totalMinutesByReport)}
              </span>
            </div>

            <div className="flex flex-row items-center justify-center w-full text-xs mb-2 gap-2">
              <span className="w-2/3 text-center text-gray-400">Nombre de la tarea / Servicio / Marca - {reportSelected?.tasksWorked?.length} tarea(s)</span>
              <span className="w-1/3 text-center text-gray-400">Tiempo en minutos - {totalMinutesByReport}</span>
            </div>

            {reportSelected?.tasksWorked?.map((task, index) =>

              <div key={index} className="flex flex-row gap-2 w-full">
                <input
                  className="text-xs w-2/3 gap-4 border border-gray-200 rounded-lg px-4 py-2"
                  type="text"
                  value={task.text}
                  disabled
                />

                <input
                  className="text-xs w-1/3 gap-4 border border-gray-200 rounded-lg px-4 py-2"
                  type="number"
                  value={task.time}
                  disabled
                />

              </div>
            )}
            
            {reportSelected.text && (
              <textarea 
                id="comment"
                rows="20"
                value={reportSelected.text}
                className="w-full text-xs border mb-4 border-gray-300 p-4 rounded-lg text-sm text-gray-900 bg-white"
                disabled
              /> 
            )}


          </div>
        </Modal>
        
        { /* Header */}
        <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center">

          <div className="flex flex-row w-full items-center gap-4 justify-between">
            <div className="flex items-center gap-4 p-4">
                <FaFileSignature className="text-zinc-700 text-2xl" />
                <h2 className="text-2xl font-bold text-zinc-700">Reporte diario</h2>
            </div>
          </div>

          <div className="flex flex-row w-full items-center justify-end gap-8">

            {/* <div className="flex flex-row items-center justify-center gap-2">
              <span className="text-xs font-semibold">Filtar a partir de: </span>
              <input 
                type="date" 
                value={reportDate}
                onChange={(e) => setReportDate(e.target.value)}
                className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              />
            </div> */}

            <div className="flex flex-row items-center justify-center gap-2">
              <span className="text-xs font-semibold">Límite </span>

              <select 
                name="limit" 
                id="limit"
                className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
              >   
                <option value={15}>15</option>
                <option value={25}>25</option>
                <option value={35}>35</option>
                <option value={45}>45</option>
                <option value={55}>55</option>
              </select>
            </div>
            
            <div className="flex flex-row items-center justify-center gap-2">
              <span className="text-xs font-semibold">Trabajador </span>

              <select 
                name="selectedWorker" 
                id="selectedWorker"
                className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={selectedWorker}
                onChange={(e) => setSelectedWorker(e.target.value)}
              >
                <option value={"Todos"}>Todos</option>
                {workers.map((worker) => (
                  <option value={worker.id}>{worker.name}</option>
                ))}
              </select>
            </div>

          </div>
        </div>
        
        {/* Body */}
        <div className="flex-grow overflow-y-auto">
          {reportsLoading ? (
            <LoadingScreen />
          ) : (
            reports.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full">
                <thead className="bg-white sticky top-0">
                  <tr className="text-gray-700 text-left text-sm uppercase font-semibold">
                    <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red" colSpan={1} rowSpan={3}>
                      Trabajador
                    </td>
                    <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red" colSpan={1} rowSpan={3}>
                      Fecha y hora
                    </td>
                    <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red" colSpan={1} rowSpan={3}>
                      Reporte
                    </td>
                    <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red" colSpan={1} rowSpan={3}>
                      Tiempo total
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((report) => {

                    const hours = Math.floor(report.totalTime / 60);
                    const minutes = report.totalTime % 60;

                    const isValidTime = !isNaN(report.totalTime)

                    return (
                      <tr key={report.id} className="text-xs py-2 hover:bg-gray-100 transition-all duration-100">
                        <td className="text-center border border-gray-300 px-4 py-2">
                          {report.user.name}
                        </td>
                        <td className="text-center border border-gray-300 px-4 py-2">
                          {formatDate(report.date)}
                        </td>
                        <td className="text-center border border-gray-300 py-2">
                          <button className="hover:underline text-xs hover-cursor-pointer transition-all duration-200" 
                            onClick={() => {
                              setActiveModal(true)
                              setReportSelected(report)
                            }}
                          >
                            Ver reporte
                          </button>
                        </td>
                        <td className="text-center border border-gray-300 px-4 py-2">
                          {isValidTime ? `${hours}h ${minutes}m` : "-"}
                        </td>

                      </tr>
                    )
                  })}
                </tbody>
              </table>
            )
          )}
        </div>

        {/* Paginador */}
        <div className="w-full flex flex-col gap-4 py-4 justify-center items-center ">
          <span className="text-sm text-gray-700 dark:text-gray-500 ">
            Mostrando
            <span className="font-semibold text-gray-900 dark:text-gray-300 ">
              {" "}
              {reports.length}
            </span>{" "}
            de
            <span className="font-semibold text-gray-900 dark:text-gray-300 ">
              {" "}
              {totalDocs}
            </span>{" "}
            reportes
          </span>
          <Pagination 
            count={totalPages}
            page={page}
            variant="outlined" 
            shape="rounded"
            onChange={handlePageChange}
          />
        </div>

      </div>
  )
}

export default ReporteDiario